import { Component, OnInit } from '@angular/core';
import { ImportExportCodesService } from '../../services/ImportExportCodes.service';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { HaEditIcdModal } from '../../models/HaEditIcd.model';
import { AlertMessages, AlertType } from '../../../../core/AlertMessages';
import { ErrorModel } from '../../../../shared/models/Error.model';
declare var $: any;

@Component({
  selector: 'app-ha-cpt-upload',
  templateUrl: './ha-cpt-upload.component.html',
  styleUrls: ['./ha-cpt-upload.component.css']
})

export class HaCptUploadComponent implements OnInit {
  title;
  nodes;
  nodeName;
  showProgress: boolean = false;
  showAlert: boolean;
  showOverlayImportCpt: boolean;
  loadingExcelPercentage;
  changeEdit: boolean = false;
  searchTermCpt: string = '';
  cptData: HaEditIcdModal[];
  sendModifiedData: HaEditIcdModal;
  Id: number;
  Name: string;
  Category: string;
  Description: string;
  isEditable: boolean;
  HelpText: string;
  sendAddData: HaEditIcdModal;
  nameFieldData: string = '';
  descriptionFieldData: string = '';
  categoryFieldData: string = '';
  helpTextFieldData: string = '';
  config: object;
  categorySelected: string = '';
  dataModel: any;
  selectCpt: any;
  mainViewError = new ErrorModel();
  cptError = new ErrorModel();
  constructor(private _service: ImportExportCodesService) {}

  ngOnInit() {
    this.cptData = [];
    this.config = {
      displayKey: 'name', //if objects array passed which key to be displayed defaults to description
      search: true, //true/false for the search functionlity defaults to false,
      height: '150px', //height of the list so that if there are more no of items it can show a scroll defaults to auto. With auto height scroll will never appear
      placeholder: 'Select', // text to be displayed when no item is selected defaults to Select,
      customComparator: () => {}, // a custom function using which user wants to sort the items. default is undefined and Array.sort() will be used in that case,
      limitTo: this.cptData.length, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
      moreText: 'more', // text to be displayed whenmore than one items are selected like Option 1 + 5 more
      noResultsFound: 'No results found!', // text to be displayed when no items are found while searching
      searchPlaceholder: 'Search Category', // label thats displayed in search input,
      searchOnKey: 'name' // key on which search should be performed this will be selective search. if undefined this will be extensive search on all keys
    }

    this.title = 'Angular tree like structure';
    this.importData();
  }

  importData() {
    this.showOverlayImportCpt = true;
    this.mainViewError.display = false;
    this._service.getCptTree().subscribe((data) => {
      this.nodes = data;
    },
    (error) => {
      this.mainViewError.error = error;
      this.mainViewError.display = true;
    }).add(() => {
      this.showOverlayImportCpt = false;
    });
  }

  selectionChanged(event) {
    if (event['value'] !== undefined) {
      if(event['value'].name != null) {
        this.categorySelected = event['value'].name;
      }
    } else {
      this.categorySelected = '';
    }
  }

  displayNodecpt(event) {
    this.nodeName = event;
  }

  arrayBuffer: any;
  file: File;

  incomingFile(event) {
    this.file = event.target.files[0];
  }

  uploadExcel() {
    this.showProgress = true;
    if (this.file == undefined || this.file == null) {
      this.showProgress = false;
      AlertMessages.Show('WARNING', 'Please choose an Excel file ( .xls ) to upload', AlertType.Warning);
    } else if (this.file.name.search(/.xls|.bmp /g) == -1) {
      this.showProgress = false;
      AlertMessages.Show('WARNING', 'Please choose an Excel file ( .xls ) to upload', AlertType.Warning);
    } else {
      this._service.uploadCptExcel(this.file).subscribe(
      (event) => {
        if (event.type == HttpEventType.UploadProgress) {
          this.loadingExcelPercentage = Math.round(event.loaded / event.total * 100);
        } else if (event.type == HttpEventType.Response) {
          AlertMessages.Show('Success', 'Cpt Excel Uploaded', AlertType.Success);
          this.alertClose();
          $('#uploadcpt').modal('hide');
        }
      }, (error: HttpErrorResponse) => {
        AlertMessages.Show('Failed', 'Could not upload sheet', AlertType.Error);
      }).add(() => {
        this.showProgress = false;
      });
    }
  }

  alertClose() {
    setTimeout(() => {
      this.showAlert = false;
      this.importData();
    }, 2000);
  }

  changeDiv() {
    this.changeEdit = true;
    this.showOverlayImportCpt = true;
    this._service.getCptAllData().subscribe(
    (data: HaEditIcdModal[]) => {
      this.cptData = data;
      this.getSelectCptData();
    },
    (error) => {
        this.changeEdit = false;
        AlertMessages.Show('Failed','Could not load data!',AlertType.Error);
    }).add(() => {
      this.showOverlayImportCpt = false;
    });
  }

  getSelectCptData() {
    this.cptError.display = false;
    this._service.getAllCptNames().subscribe(
    (data) => {
      this.selectCpt = data;
    },
    (error) => {
      AlertMessages.Show('Failed', 'Could not get data!', AlertType.Error);
      this.cptError.error = error;
      this.cptError.display = true;
    });

  }

  changeShow() {
    this.changeEdit = false;
    this.importData();
  }

  editCpt(id, idd, name, category, description, helpText) {
    this.sendModifiedData = new HaEditIcdModal();
    if (name == '' || name == null || name == undefined) {
      AlertMessages.Show('Warning', 'Name field cannot be empty!!!', AlertType.Warning);
    } else {
      let index = this.cptData.findIndex(code => code.id == id);
      this.cptData[index].id = id;
      this.cptData[index].name = name;
      this.cptData[index].category = category;
      this.cptData[index].description = description;
      this.cptData[index].helpText = helpText;
      this.cptData[index].isEditable = false;
      this.sendModifiedData.id = id;
      this.sendModifiedData.name = name;
      this.sendModifiedData.category = category;
      this.sendModifiedData.description = description;
      this.sendModifiedData.helpText = helpText;
      this.sendModifiedData.isEditable = false;
      this._service.updateCptData(this.sendModifiedData).subscribe(
      (data) => {
        AlertMessages.Show('Success', 'Cpt Code Updated', AlertType.Success);
      },
      (error) => {
        AlertMessages.Show('Failed', 'Could not update!', AlertType.Error);
      });
    }

  }

  saveCptNew(formData) {
    this.sendAddData = new HaEditIcdModal();
    if (formData.name == '' || formData.name == null || formData.name == undefined) {
      AlertMessages.Show('Warning', 'Please Enter Name', AlertType.Warning);
    } else {
      this.sendAddData.name = formData.name;
      this.sendAddData.category = this.categorySelected;
      this.sendAddData.description = formData.description;
      this.sendAddData.helpText = formData.note;
      this.sendAddData.isEditable = false;
      this._service.insertCptData(this.sendAddData).subscribe(
      (data: HaEditIcdModal) => {
          AlertMessages.Show('Success', 'Cpt Code Added Successfully', AlertType.Success);
          this.cptData.splice(0, 0, data);
          this.resetData();
      },
      (error) => {
        AlertMessages.Show('Failed', 'Code Not inserted', AlertType.Error);
      });
    }
  }

  resetData() {
    this.nameFieldData = '';
    this.descriptionFieldData = '';
    this.categoryFieldData = '';
    this.helpTextFieldData = '';
    this.dataModel = '';
  }

}
